const providerContextReducer = (state, action) => {
  switch (action.type) {
    case 'fetching':
      return {
        ...state,
        [action.stateName]: {
          ...state[action.stateName],
          error: null,
          loading: true,
          ...action.payload
        }
      };
    case 'success':
      // don't update state if the payload params does not match the requested filters
      if (action.payload?.filter && state[action.stateName].filter) {
        for (const key in action.payload?.filter) {
          if (
            action.payload?.filter[key] !== state[action.stateName].filter[key]
          ) {
            return state;
          }
        }
      }

      return {
        ...state,
        [action.stateName]: {
          ...state[action.stateName],
          loading: false,
          lastUpdated: new Date().getTime(),
          ...action.payload
        }
      };
    case 'error':
      return {
        ...state,
        [action.stateName]: {
          ...state[action.stateName],
          error: action.payload,
          loading: false
        }
      };
    case 'replace':
      return {
        ...state,
        [action.stateName]: {
          ...state[action.stateName],
          loading: false,
          lastUpdated: new Date().getTime(),
          ...action.payload,
          value: [
            ...state[action.stateName].value.filter(action.payload.filter),
            ...(Array.isArray(action.payload.value)
              ? action.payload.value
              : [action.payload.value])
          ]
        }
      };
    case 'append':
      return {
        ...state,
        [action.stateName]: {
          ...state[action.stateName],
          loading: action.payload.loading || false,
          lastUpdated: new Date().getTime(),
          value: [
            ...state[action.stateName].value,
            ...(Array.isArray(action.payload.value)
              ? action.payload.value
              : [action.payload.value])
          ]
        }
      };
    case 'paginated-append':
      return {
        ...state,
        [action.stateName]: {
          ...state[action.stateName],
          loading: false,
          lastUpdated: new Date().getTime(),
          ...action.payload,
          data: [
            ...state[action.stateName].data,
            ...(Array.isArray(action.payload.data)
              ? action.payload.data
              : [action.payload.data])
          ]
        }
      };
    case 'paginated-replace-index': {
      const dataCopy = [...state[action.stateName].data];
      const index = dataCopy.findIndex(action.payload.filter);
      if (index >= 0) {
        dataCopy[index] = action.payload.value;
      }

      return {
        ...state,
        [action.stateName]: {
          ...state[action.stateName],
          data: dataCopy,
          loading: false,
          lastUpdated: new Date().getTime()
        }
      };
    }
    case 'remove':
      return {
        ...state,
        [action.stateName]: {
          ...state[action.stateName],
          value: state[action.stateName].value.filter(action.payload),
          loading: false,
          lastUpdated: new Date().getTime()
        }
      };
    case 'set':
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};

export { providerContextReducer };
